// src/components/ApiError.jsx — affichage d'erreur réseau avec retry
import React from "react";
import { Alert, Button, Stack } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

/**
 * ApiError — affiche une alerte MUI avec un bouton "Réessayer".
 *
 * Props :
 *   message  — message d'erreur (string)
 *   onRetry  — callback au clic sur "Réessayer" (optionnel)
 */
export default function ApiError({ message, onRetry }) {
  if (!message) return null;
  return (
    <Alert
      severity="error"
      sx={{ borderRadius: "10px", mb: 2 }}
      action={
        onRetry ? (
          <Button
            size="small"
            startIcon={<RefreshIcon />}
            onClick={onRetry}
            sx={{ fontWeight: 700, textTransform: "none" }}
          >
            Réessayer
          </Button>
        ) : undefined
      }
    >
      {message}
    </Alert>
  );
}